import React from 'react'
import { Link } from 'react-router-dom'
import PageLayout from '../components/PageLayout'
import { ROUTES } from '../resources/routes-constants'

const NotFoundPage: React.FC = () => {
    return (
        <PageLayout showGmaBanner={false}>
            <section className="page-section text-center">
                <div className="container">
                    <p className="text-uppercase fw-bold">404 error</p>
                    <h1>We couldn&apos;t find that page</h1>
                    <p className="lead readable-copy">The page may have moved, or the address may be incorrect.</p>
                    <Link className="btn btn-primary btn-lg mt-3" to={ROUTES.MAINPAGE_ROUTE}>
                        Return home
                    </Link>
                </div>
            </section>
        </PageLayout>
    )
}

export default NotFoundPage
